import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-app-page-not-found',
  templateUrl: './app-page-not-found.component.html'
})
export class AppPageNotFoundComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
